export default __webpack_public_path__ + "static/media/undraw.985dab4e.png";